import { render, staticRenderFns } from "./fascia_massage.vue?vue&type=template&id=5fbdedaa&scoped=true&"
import script from "./fascia_massage.vue?vue&type=script&lang=js&"
export * from "./fascia_massage.vue?vue&type=script&lang=js&"
import style0 from "./fascia_massage.vue?vue&type=style&index=0&id=5fbdedaa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fbdedaa",
  null
  
)

export default component.exports